module.exports = __webpack_public_path__ + "pause_icon.svg?c5834a48a8e18ecc43d38d78fcebdbf8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pause_icon.svg
// module id = 31
// module chunks = 0